import * as API from "./";

export default {

  /*上传文件*/
  uploadFile: params => {
    return API.POSTFILE(BASEURL + '/api/v1/file/upload', params);
  },

  //获取单个字段表项 20220527--suzhenhua
  getDicByCategory: params => {
    return API.GETURL(SYSSERVER + "/api/v1/dic/list/dic", params);
  },
  /*字典查询*/
  getDictionariesByDicname: params => {
    return API.GET(BASEURL + "/api/v1/dic/getDic", params);
  },

  /*新字典接口*/
  getDictionariesByDicnameNew: params => {
    return API.POST(SYSSERVER + "/api/v1/dic/list", params);
  },

  /*字体库、符号库 字典表接口*/
  getDictionariesByUrl: params => {
    return API.GET(MAPSERVER + params.url);
  },

  // 统一用户平台字典
  getUserPlatformDic: params => {
    return API.POST(SYSSERVER + "/api/v1/dic/list", params);
  },

  /*通过区划代码和年份查询省市县行政区*/
  get_xzq_by_year: params => {
    return API.GET(BASEURL + "/api/v1/Dictionaries/getXzqByYear", params);
  },

  /*解析txt文件接口*/
  getSpatialInfo: params => {
    return API.GET(BASEURL + "/api/v1/file/getSpatialInfo", params);
  },

  /*CGCS2000转换为经纬度*/
  prj2jwdcoord: params => {
    return API.POST(BASEURL + "/api/vi/dataconvert/prj2jwdcoord", params);
  },

  /*请求url*/
  getUrl: url => {
    return API.GET(url);
  },

  getUrlBuffer: url => {
    return API.GETBUFFER(url);
  },

  //-------------------- 区划接口 begin------------------------
  /*区划详情接口*/
  getAreaDetail: params => {
    return API.GET(BASEURL + "/api/v1/area/areaDetail", params);
  },

  /*区划下钻接口*/
  getAreaDrillDown: params => {
    return API.GET(BASEURL + "/api/v1/area/areaDrillDown", params);
  },

  /*
   * 区划树
   * 如果是整个湖南省(43)的区划，不建议用此接口，数据太多，并且还要组织成树状返回，接口响应太慢
   * */
  getAreaTree: params => {
    return API.GET(
      BASEURL + "/api/v1/area/areaTree?qhdm=" + params + "&havGeojson=false"
    );
  },

  /*字典树结构*/

  treeList: params => {
    return API.GET(BASEURL + "/api/v1/dic/treeList", params);
  },
  //根据id获取子集
  getByPid: params => {
    return API.GET(BASEURL + "/api/v1/dic/getByPid", params);
  },

  // 农资类型
  agriTypeList: params => {
    return API.POST(
      SHOPSERVER + "/api/v1/web/sp/product/category/child/list",
      params
    );
  },

  // 驾驶舱首页菜单
  mainMenu: params => {
    return API.POST(ACCOUNTSERVER + "/api/v1/menu/tree/list", params);
  },
  // 点击菜单查询权限
  menuAuth: params => {
    return API.POST(ACCOUNTSERVER + "/api/v1/role/menu/auth", params);
  }
};



// WEBPACK FOOTER //
// ./src/api/api_common.js